export enum ImportErrorSeverity {
    Critical = 1,
    Error = 0,
    Warning = -1,
    Info = -2,
}
